import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import Button from "../../common/Button";
import TextBox from "../../common/TextBox";
import useAuth from "../../../hooks/useAuth";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";

import { ReactComponent as ExpiredBannerSvg } from "../../../assets/auth/changePassword/expired-banner.svg";
import { ReactComponent as EmailSvg } from "../../../assets/icons/email.svg";
import { ReactComponent as ArrowRightSvg } from "../../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowRightDisabledSvg } from "../../../assets/icons/arrow-right-disabled.svg";

import { toast } from "react-toastify";

const Expired = (props) => {
  const { createPasswordReset } = useAuth();
  const [submitted, setSubmitted] = useState(false);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.auth);
  const TranslationCommon = getLang(langComponent.common);

  // * Handle submit
  const handleSubmit = async ({ email }) => {
    try {
      await createPasswordReset(email);
      setSubmitted(true);
    } catch (error) {
      toast.error("Not found email");
    }
  };

  return (
    <div className="change-password">
      <ExpiredBannerSvg />
      <h1 className="change-password-exp__header">
        {Translation("Your reset request has expired")}
      </h1>
      {!submitted ? (
        <>
          <span className="change-password-exp__desc">
            {Translation("Please enter in your email again to reset")}
          </span>

          <Formik
            initialValues={{ email: "" }}
            validate={({ email }) => {
              let errors = {};

              if (!email) errors.email = Translation("Please specify an email");

              if (email) {
                // * Check if email is valid
                const validEmaiLRegex =
                  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                if (!email.match(validEmaiLRegex)) {
                  errors.email = Translation("Invalid email");
                }
              }

              return errors;
            }}
            onSubmit={handleSubmit}
          >
            {({ isValid }) => {
              return (
                <>
                  <Form>
                    <TextBox
                      name="email"
                      label={Translation("Email")}
                      placeholder={Translation("Email")}
                      type="text"
                      leadingIcon={<EmailSvg />}
                    />
                    <Button
                      type="submit"
                      label={TranslationCommon("Confirm")}
                      trailingIcon={
                        isValid ? <ArrowRightSvg /> : <ArrowRightDisabledSvg />
                      }
                      style={{ margin: "20px 0 40px 0", width: "300px" }}
                      disabled={!isValid}
                    />
                  </Form>
                </>
              );
            }}
          </Formik>
        </>
      ) : (
        <span className="change-password-exp__desc">
          {Translation("New request sent, please check your inbox")}
        </span>
      )}
    </div>
  );
};

Expired.propTypes = {};

export default Expired;
